import React from 'react';
import { useField } from 'formik';
import TextField from '@mui/material/TextField';


export const EditField = ({ label, required, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <TextField
      required={required}
      fullWidth
      label={label}
      variant="outlined"
      helperText={meta.touched && meta.error}
      error={meta.touched && !!meta.error}
      {...field}
      {...props}
    />
  );
};
